<template>
    <div class="col-12 mb-primary">
        <div class="card card-with-shadow border-0 h-100">
            <div class="card-header p-primary bg-transparent">
                <h5 class="card-title m-0">{{ $t('update_blog') }}</h5>
            </div>
            <app-overlay-loader v-if="preloader"/>
            <div class="card-body">
                 <form ref="form" :data-url='`/blog/update/${blogdata.id}`' class="mb-0" :class="{'loading-opacity': preloader}" enctype="multipart">
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('parent') }}
                        </label>

                        <app-input class="col-md-8"
                                   type="select"
                                   v-model="blogdata.blog_category_id"
                                   :list="categories"/>
                    </div>
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('title') }}
                        </label>
                        <app-input class="col-md-8"
                                   type="text"
                                   v-model="blogdata.title"
                                   :required="true"
                                   :placeholder="$t('title_name')"/>
                    </div>
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('author') }}
                        </label>
                        <app-input class="col-md-8"
                                   type="text"
                                   v-model="blogdata.author"
                                   :required="false"
                                   :placeholder="$t('author_name')"/>
                    </div>
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('short_description') }}
                        </label>
                        <app-input class="col-md-8"
                                   type="textarea"
                                   v-model="blogdata.short_description"
                                   :required="false"
                                   :rows="5"
                                   :maxlength="200"
                                   :placeholder="$t('short_description_name')"/>
                    </div>
                    <div class="form-group row">
                        <label for="inputs_editor" class="col-sm-2 h-fit-content">
                            {{ $t('description') }}
                        </label>
                        <div class="col-sm-8">
                            <app-input type="text-editor"
                                       :required="false"
                                       id="text-editor-id"
                                       :label="$t('message_placeholder')" v-model="blogdata.description"/>
                        </div>
                    </div>
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('meta_keyword') }}
                        </label>
                        <app-input class="col-md-8"
                                   type="text"
                                   v-model="blogdata.meta_keyword"
                                   :required="false"
                                   :placeholder="$t('meta_key_name')"/>
                    </div>
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('meta_title') }}
                        </label>
                        <app-input class="col-md-8"
                                   type="text"
                                   v-model="blogdata.meta_title"
                                   :required="false"
                                   :placeholder="$t('meta_title_name')"/>
                    </div>
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('meta_description') }}
                        </label>
                        <app-input class="col-md-8"
                                   type="text"
                                   v-model="blogdata.meta_description"
                                   :required="false"
                                   :placeholder="$t('meta_description_name')"/>
                    </div>                    
                    
                    <div class="form-group row mb-0">
                        <label class="col-sm-2 mb-sm-0">
                            {{ $t('upload_image') }}
                        </label>
                        <div class="col-sm-4">
                            <app-input type="custom-file-upload"
                                       :label="$t('upload_your_file')"
                                       v-model="reqData.featured_image"/>
                        </div>
                        <div class="custom-image-upload-wrapper" v-if="blogdata.featured_image">
                            <app-avatar :title="$t('avatars')" class="image-area d-flex" :img="blogdata.featured_image"
                                  :alt-text="$t('not_found')"/>         
                        </div>
                    </div>

                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('status') }}
                        </label>
                            <app-input class="col-md-8 mt-2 pt-1"
                                       type="radio"
                                       :list="statusLists"
                                       v-model="blogdata.status"/>
                    </div>
                    <div class="mt-5 action-buttons">
                        <button type="submit" class="btn btn-primary mr-2" @click.prevent="submit">
                            {{ $t('submit')}}
                        </button>
                        <button type="submit" class="btn btn-secondary" @click.prevent="clear">
                            {{ $t('clear') }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import {axiosPost} from "../../../../Helpers/AxiosHelper";  
    import {FormMixin} from "../../../../../core/mixins/form/FormMixin"; 
    import * as actions from '../../../../Config/ApiUrl';
    export default {
        name: "UpdateCMS",
        mixins: [FormMixin],
        props: ['blogdata','categories'],
        data(){
          return {
            preloader: false,
            reqData: {},                
                statusLists: [
                    {id: 'active', value: "Active"},
                    {id: 'inactive', value: "Inactive"},
                ]
          }
        },
        methods: {
            beforeSubmit(){
                this.preloader = true;
            },
            submit() {
                let formData = new FormData;
                for (const [key, value] of Object.entries(this.blogdata)) {
                    if (value != null) formData.append(key, value);
                }
                if (this.reqData.featured_image) {
                    formData.append("featured_image", this.reqData.featured_image);
                }
                this.save(formData);
            },
            afterSuccess(res) {
                this.$toastr.s(res.data.message);
                window.location.reload();
            },
            afterFinalResponse() {
                this.preloader = false;
            },
            afterError(res) {
                this.$toastr.e(res.data.message);
            },
            clear() {
                this.fieldStatus = {
                    isSubmit: false
                }
            },
        }
    }
</script>